<template>
  <el-input-number :value="value" controls-position="right" :min="1" :max="100" v-bind="$listeners" v-on="$listeners">
    <i slot="suffix" class="el-input__icon el-icon-date" />
  </el-input-number>
</template>
<script>
export default {
  props: {
    // eslint-disable-next-line
    value: {}
  },
  data() {
    return {
    }
  }
}
</script>
